import { useTranslation } from 'react-i18next';
import { IMembershipPlan } from '../../types/model';
import { Icon } from '../../components/UI';

export const WelcomePack = ({ className }: { className?: string }) => {
  const { t } = useTranslation();

  return (
    <div
      className={`bg-grey-10 font-normal px-2 rounded-md flex gap-1 items-center ${className}`}
    >
      <span>+</span>
      {t('choosePlan.welcomePack')}
      <Icon className="text-grey-10" svgName="gift" />
    </div>
  );
};

export const CheckWithLabel = ({
  active,
  label,
}: {
  active?: boolean;
  label: string;
}) => {
  return (
    <div className="inline-flex items-center text-left">
      <span>
        <Icon
          svgName="check"
          className={`w-5 h-5 ${
            active ? 'bg-lime' : 'bg-grey-30 text-white'
          } rounded-full p-1`}
        />
      </span>
      <span className={`pl-3 ${active ? 'text-grey-70' : 'text-grey-50'}`}>
        {label}
      </span>
    </div>
  );
};

export enum PLAN_COLORS {
  Arthur = 'black',
  Excalibur = 'lime',
  Lancelot = 'grey-30',
  Camelot = 'grey-5',
}

export const getPlanClasses = (membershipPlan: IMembershipPlan) => {
  const bgColor = PLAN_COLORS[membershipPlan.title];
  const textColor = bgColor === 'black' ? 'white' : 'black';

  return `bg-${bgColor} text-${textColor}`;
};
